export default __webpack_public_path__ + "static/media/502.669eb47c.jpg";